<ng-container *ngIf="isReadOnly; else showInputSelect">
  <div
    *ngIf="isBreakLineWhenReadonly"
    [innerText]="
      this.bindingFormControl?.value === null ||
      this.bindingFormControl?.value === undefined ||
      this.bindingFormControl?.value?.trim() === ''
        ? '-'
        : this.bindingFormControl?.value
    "
  ></div>
  <div
    *ngIf="!isBreakLineWhenReadonly"
    sigvValueDiffItem="contractFormat"
    class="p-text-bold-500"
  >
    {{ this.bindingFormControl?.value | replaceNullWith : '-' }}
  </div>
</ng-container>
<ng-template #showInputSelect>
  <sigv-form-control-widget
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
  >
    <textarea
      (onResize)="onResizeEvent($event)"
      *ngIf="render"
      name="textarea"
      pInputTextarea
      [autoResize]="autoResize"
      [maxLength]="maxLen"
      [rows]="rows"
      [readonly]="ifDisabled"
      [formControl]="bindingFormControl"
      (keyup)="onTextAreaKeyUp($event)"
      (ngModelChange)="onChangeEvent($event)"
      [class]="class"
      placeholder=" {{
        (placeholder == undefined ? 'Please Enter' : placeholder) | translate
      }}"
    ></textarea>
    <small *ngIf="isShowLength" class="float-right">
      {{ textareaLength }}
      &nbsp;/&nbsp;
      <span class="p-text-primary">{{ maxLen }}</span>
    </small>
  </sigv-form-control-widget>
</ng-template>
